import { iScanResult, iScanTicket } from 'services/Ticketing/Ticketing.type';

export type TicketInfo = Omit<iScanTicket, 'category'> & {
  category: string | null;
};
export type ScanResult = Omit<iScanResult, 'counters' | 'ticket'> & {
  ticket: TicketInfo | null;
};
export type LookupResult = TicketInfo & { raw_code: string };

/** Ticket code from a QR code ("BBT:XXXX") or a typed code ("ABCD-EFGH-…"). */
export function codeFromScan(value: string): string {
  let v = value.trim().toUpperCase();
  if (v.startsWith('BBT:')) v = v.slice(4);
  return v.replace(/[^A-Z0-9]/g, '');
}
